<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row>
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <el-row>
        <el-select
          v-model="selectvalue"
          @change="rebuildChart('main')"
          style="width: 21%; margin-left: 0; padding: 0"
        >
          <el-option
            v-for="item in selectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="search"
          placeholder="検索ワードを入力"
          clearable
          style="width: 23%; margin-left: 10px; margin-right: 10px"
          @change="filterEchart()"
        ></el-input>
        <!-- <el-button
          icon="el-icon-sort"
          circle
          size="small"
          @click="sortList()"
        ></el-button> -->
        <span style="padding: 0 5px 0 5px">{{
          this.$root.htmlConst.cons_223_aggregate_period
        }}</span>
        <el-date-picker
            v-model="datePicker"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="〜"
            :picker-options="pickerOptions"
            @change="rebuildChart('main')"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            :clearable="false"
          >
          </el-date-picker>
      </el-row>
      <hr />
      <el-row>
        <echarts
          :autoresize="true"
          class="chart-view2"
          :option="option"
          @legendselectchanged="legendselectchanged"
        />
      </el-row>
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold; margin-right: 10px">{{
              displayTitle
            }}</span>
          </el-row>
          <el-row>
            <el-select
              v-model="selectvalue"
              @change="rebuildChart('popup')"
              style="width: 21%; margin-left: 0; padding: 0"
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="search"
              placeholder="検索ワードを入力"
              clearable
              style="width: 23%; margin-left: 10px; margin-right: 10px"
              @change="filterEchart()"
            ></el-input>
            <!-- <el-button
              icon="el-icon-sort"
              circle
              size="small"
              @click="sortList()"
            ></el-button> -->
            <span style="padding: 0 5px 0 5px">{{
              this.$root.htmlConst.cons_223_aggregate_period
            }}</span>
            <el-date-picker
                v-model="datePicker"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="〜"
                :picker-options="pickerOptions"
                @change="rebuildChart('popup')"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                :clearable="false"
              >
              </el-date-picker>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
          @legendselectchanged="legendselectchanged"
        />
      </el-dialog>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
var _ = require("lodash");
export default {
  name: "ChatbotSupportCompatibilityLevelChart",
  props: ["title", "displayTitle"],
  data() {
    let _this = this;
    return {
      option: this.option,
      loading: this.loading,
      popupLoading: this.popupLoading,
      popUpDisplay: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "Last Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 30);

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      datePicker: [this.$root.startDate, this.$root.endDate],
      search: "",
      selectOptions: [
        {
          value: "上位10件",
          label: "上位10件",
        },
        {
          value: "上位20件",
          label: "上位20件",
        },
        {
          value: "上位100件",
          label: "上位100件",
        },
        {
          value: "下位10件",
          label: "下位10件",
        },
        {
          value: "下位20件",
          label: "下位20件",
        },
        {
          value: "下位100件",
          label: "下位100件",
        },
        {
          value: "全件",
          label: "全件",
        },
      ],
      selectvalue: "上位10件",
      data_list: [],
      operatorList: [],
    };
  },
  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.datePicker = [startDate, endDate];
      this.rebuildChart("main");
    });
  },
  created() {
    let self = this;
    self.loading = true;

    api
      .getChatbotSupportCompatibilityLevel(
        self.datePicker[0],
        self.datePicker[1],
        self.selectvalue
      )
      .then(
        (res) => {
          let data = res.data;
          self.data_list = data.output_list;
          self.operatorList = data.operatorList;
          self.option = {
            color: ["#50951F", "#6BC82A", "#A5E37B", "#C3ECA7", "#E1F5D3", "#D9D9D9"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            legend: {
              data: ["~100%", "~90%", "~80%", "~70%", "~60%", "不明"],
              selected: {
                "~100%": true,
                "~90%": true,
                "~80%": true,
                "~70%": true,
                "~60%": true,
                不明: true,
              },
            },
            dataZoom: [
              {
                type: "slider",
                show: true,
                yAxisIndex: [0],
                showDetail: false,
                start: 100,
                end: self.computedPosition(
                  1,
                  self.data_list.unknownList.length
                ),
                maxValueSpan: 5,
                width: 10,
                fillerColor: "#269cdb",
                borderRadius: 5,
                showDataShadow: false,
                realtime: true,
                zoomLock: true,
                filterMode: "filter",
              },
              {
                type: "inside",
                yAxisIndex: 0,
                zoomOnMouseWheel: false,
                moveOnMouseMove: true,
                moveOnMouseWheel: true,
              },
            ],
            grid: {
              top: "8%",
              bottom: "10%",
              left: "5%",
              right: "5%",
            },
            xAxis: {
              type: "value",
              axisLabel: {
                formatter: function (value) {
                  return value;
                },
              },
            },
            yAxis: {
              type: "category",
              axisLabel: {
                inside: true,
                color: "#000055",
                z: 1,
              },
              data: self.operatorList.map((v) => v.operatorName),
            },
            series: [
              {
                name: "~100%",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.hundredList.map((v) => v.count),
              },
              {
                name: "~90%",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.ninetyList.map((v) => v.count),
              },
              {
                name: "~80%",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.eightyList.map((v) => v.count),
              },
              {
                name: "~70%",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.seventyList.map((v) => v.count),
              },
              {
                name: "~60%",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.sixtyList.map((v) => v.count),
              },
              {
                name: "不明",
                type: "bar",
                stack: "总量",
                barWidth: 40,
                barMaxWidth: 40,
                z: 0,
                data: self.data_list.unknownList.map((v) => v.count),
              },
            ],
          };
          self.loading = false;
        },
        (err) => {
          console.log(err);
        }
      );
  },
  methods: {
    sortList() {
      this.operatorList = _.reverse(this.operatorList);
      this.data_list.unknownList = _.reverse(this.data_list.unknownList);
      this.data_list.sixtyList   = _.reverse(this.data_list.sixtyList );
      this.data_list.seventyList = _.reverse(this.data_list.seventyList );
      this.data_list.eightyList  = _.reverse(this.data_list.eightyList );
      this.data_list.ninetyList  = _.reverse(this.data_list.ninetyList );
      this.data_list.hundredList = _.reverse(this.data_list.hundredList );
      this.option = {
        color: ["#50951F", "#6BC82A", "#A5E37B", "#C3ECA7", "#E1F5D3", "#D9D9D9"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["~100%", "~90%", "~80%", "~70%", "~60%", "不明"],
          selected: {
            "~100%": true,
            "~90%": true,
            "~80%": true,
            "~70%": true,
            "~60%": true,
            不明: true,
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            yAxisIndex: [0],
            showDetail: false,
            start: 100,
            end: this.computedPosition(1, this.data_list.unknownList.length),
            maxValueSpan: 5,
            width: 10,
            fillerColor: "#269cdb",
            borderRadius: 5,
            showDataShadow: false,
            realtime: true,
            zoomLock: true,
            filterMode: "filter",
          },
          {
            type: "inside",
            yAxisIndex: 0,
            zoomOnMouseWheel: false,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
        grid: {
          top: "8%",
          bottom: "10%",
          left: "5%",
          right: "5%",
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return value;
            },
          },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            inside: true,
            color: "#000055",
            z: 1,
          },
          data: this.operatorList.map((v) => v.operatorName),
        },
        series: [
          {
            name: "~100%",
            type: "bar",
            stack: "总量",
            z: 0,
            data: self.data_list.hundredList.map((v) => v.count),
          },
          {
            name: "~90%",
            type: "bar",
            stack: "总量",
            z: 0,
            data: self.data_list.ninetyList.map((v) => v.count),
          },
          {
            name: "~80%",
            type: "bar",
            stack: "总量",
            z: 0,
            data: self.data_list.eightyList.map((v) => v.count),
          },
          {
            name: "~70%",
            type: "bar",
            stack: "总量",
            z: 0,
            data: self.data_list.seventyList.map((v) => v.count),
          },
          {
            name: "~60%",
            type: "bar",
            stack: "总量",
            z: 0,
            data: self.data_list.sixtyList.map((v) => v.count),
          },
          {
            name: "不明",
            type: "bar",
            stack: "总量",
            barWidth: 40,
            barMaxWidth: 40,
            z: 0,
            data: self.data_list.unknownList.map((v) => v.count),
          },
        ],
      };
    },
    computedPosition(length, xArraylength) {
      if (xArraylength > 5) {
        return 104 - (5 / xArraylength) * 100;
      } else {
        return 0;
      }
    },
    filterEchart() {
      this.option = {
        color: ["#50951F", "#6BC82A", "#A5E37B", "#C3ECA7", "#E1F5D3", "#D9D9D9"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["~100%", "~90%", "~80%", "~70%", "~60%", "不明"],
          selected: {
            '~100%': true,
            '~90%': true,
            '~80%': true,
            '~70%': true,
            '~60%': true,
            不明: true,
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            yAxisIndex: [0],
            showDetail: false,
            start: 100,
            end: this.computedPosition(1, this.data_list.unknownList.length),
            maxValueSpan: 5,
            width: 10,
            fillerColor: "#269cdb",
            borderRadius: 5,
            showDataShadow: false,
            realtime: true,
            zoomLock: true,
            filterMode: "filter",
          },
          {
            type: "inside",
            yAxisIndex: 0,
            zoomOnMouseWheel: false,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
        grid: {
          top: "8%",
          bottom: "10%",
          left: "5%",
          right: "5%",
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return value;
            },
          },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            inside: true,
            color: "#000055",
            z: 1,
          },
          data: this.operatorList
            .map((v) => v.operatorName)
            .filter(
              (data) =>
                !this.search ||
                data.toLowerCase().includes(this.search.toLowerCase())
            ),
        },
        series: [
          {
            name: "~100%",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.hundredList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "~90%",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.ninetyList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "~80%",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.eightyList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "~70%",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.seventyList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "~60%",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.sixtyList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "不明",
            type: "bar",
            stack: "总量",
            barWidth: 40,
            barMaxWidth: 40,
            z: 0,
            data: this.data_list.unknownList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
        ],
      };
    },
    showPopUp() {
      this.popUpDisplay = true;
    },
    rebuildChart(value) {
      this.search = "";
      let self = this;
      if (value == "main") {
        self.loading = true;
      } else {
        self.popupLoading = true;
      }

      api
        .getChatbotSupportCompatibilityLevel(
          self.datePicker[0],
          self.datePicker[1],
          self.selectvalue
        )
        .then(
          (res) => {
            let data = res.data;
            self.data_list = data.output_list;
            self.operatorList = data.operatorList;
            self.option = {
              color: ["#50951F", "#6BC82A", "#A5E37B", "#C3ECA7", "#E1F5D3", "#D9D9D9"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              legend: {
                data: ["~100%", "~90%", "~80%", "~70%", "~60%", "不明"],
                selected: {
                  '~100%': true,
                  '~90%': true,
                  '~80%': true,
                  '~70%': true,
                  '~60%': true,
                  不明: true,
                },
              },
              dataZoom: [
                {
                  type: "slider",
                  show: true,
                  yAxisIndex: [0],
                  showDetail: false,
                  start: 100,
                  end: self.computedPosition(
                    1,
                    self.data_list.unknownList.length
                  ),
                  maxValueSpan: 5,
                  width: 10,
                  fillerColor: "#269cdb",
                  borderRadius: 5,
                  showDataShadow: false,
                  realtime: true,
                  zoomLock: true,
                  filterMode: "filter",
                },
                {
                  type: "inside",
                  yAxisIndex: 0,
                  zoomOnMouseWheel: false,
                  moveOnMouseMove: true,
                  moveOnMouseWheel: true,
                },
              ],
              grid: {
                top: "8%",
                bottom: "10%",
                left: "5%",
                right: "5%",
              },
              xAxis: {
                type: "value",
                axisLabel: {
                  formatter: function (value) {
                    return value;
                  },
                },
              },
              yAxis: {
                type: "category",
                axisLabel: {
                  inside: true,
                  color: "#000055",
                  z: 1,
                },
                data: self.operatorList.map((v) => v.operatorName),
              },
              series: [
                {
                  name: "~100%",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.hundredList.map((v) => v.count),
                },
                {
                  name: "~90%",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.ninetyList.map((v) => v.count),
                },
                {
                  name: "~80%",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.eightyList.map((v) => v.count),
                },
                {
                  name: "~70%",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.seventyList.map((v) => v.count),
                },
                {
                  name: "~60%",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.sixtyList.map((v) => v.count),
                },
                {
                  name: "不明",
                  type: "bar",
                  stack: "总量",
                  barWidth: 40,
                  barMaxWidth: 40,
                  z: 0,
                  data: self.data_list.unknownList.map((v) => v.count),
                },
              ],
            };
            if (value == "main") {
              self.loading = false;
            } else {
              self.popupLoading = false;
            }
          },
          (err) => {
            console.log(err);
          }
        );
    },
    legendselectchanged(params) {
      this.search = "";
      if (params.selected["~100%"] == true) {
        this.option.legend.selected["~100%"] = true;
        this.option.series[0].data = this.data_list.hundredList.map(
          (v) => v.count
        );
      } else {
        this.option.legend.selected["~100%"] = false;
        this.option.series[0].data = [];
      }

      if (params.selected["~90%"] == true) {
        this.option.legend.selected["~90%"] = true;
        this.option.series[1].data = this.data_list.ninetyList.map(
          (v) => v.count
        );
      } else {
        this.option.legend.selected["~90%"] = false;
        this.option.series[1].data = [];
      }

      if (params.selected["~80%"] == true) {
        this.option.legend.selected["~80%"] = true;
        this.option.series[2].data = this.data_list.eightyList.map(
          (v) => v.count
        );
      } else {
        this.option.legend.selected["~80%"] = false;
        this.option.series[2].data = [];
      }

      if (params.selected["~70%"] == true) {
        this.option.legend.selected["~70%"] = true;
        this.option.series[3].data = this.data_list.seventyList.map(
          (v) => v.count
        );
      } else {
        this.option.legend.selected["~70%"] = false;
        this.option.series[3].data = [];
      }

      if (params.selected["~60%"] == true) {
        this.option.legend.selected["~60%"] = true;
        this.option.series[4].data = this.data_list.sixtyList.map(
          (v) => v.count
        );
      } else {
        this.option.legend.selected["~60%"] = false;
        this.option.series[4].data = [];
      }

      if (params.selected["不明"] == true) {
        this.option.legend.selected["不明"] = true;
        this.option.series[5].data = this.data_list.unknownList.map(
          (v) => v.count
        );
      } else {
        this.option.legend.selected["不明"] = false;
        this.option.series[5].data = [];
      }

      this.option.yAxis.data = this.operatorList.map((v) => v.operatorName);
      // if (
      //   params.selected["NGワード"] == true &&
      //   params.selected["NGマナー"] == true
      // ) {
      //   this.option.legend.selected["NGワード"] = true;
      //   this.option.legend.selected["NGマナー"] = true;
      //   this.option.series[0].data = this.data_list.unknownList.map(
      //     (v) => v.count
      //   );
      //   this.option.series[1].data = this.data_list.ngMannerList.map(
      //     (v) => v.count
      //   );
      //   this.option.yAxis.data = this.operatorList.map((v) => v.operatorName);
      // } else if (
      //   params.selected["NGワード"] == false &&
      //   params.selected["NGマナー"] == true
      // ) {
      //   this.option.legend.selected["NGワード"] = false;
      //   this.option.legend.selected["NGマナー"] = true;
      //   this.option.series[0].data = [];
      //   this.option.series[1].data = this.data_list.ngMannerList
      //     .map((v) => v.count)
      //     .sort(function (a, b) {
      //       return a - b;
      //     });
      //   let ngMannerList = JSON.parse(
      //     JSON.stringify(this.data_list.ngMannerList)
      //   );
      //   this.option.yAxis.data = [];
      //   for (let count of this.option.series[1].data) {
      //     for (let [index, ngmanner] of ngMannerList.entries()) {
      //       if (count == ngmanner.count) {
      //         this.option.yAxis.data.push(ngmanner.operatorName);
      //         ngMannerList.splice(index, 1);
      //         break;
      //       }
      //     }
      //   }
      // } else if (
      //   params.selected["NGワード"] == true &&
      //   params.selected["NGマナー"] == false
      // ) {
      //   this.option.legend.selected["NGワード"] = true;
      //   this.option.legend.selected["NGマナー"] = false;
      //   this.option.series[1].data = [];
      //   this.option.series[0].data = this.data_list.unknownList
      //     .map((v) => v.count)
      //     .sort(function (a, b) {
      //       return a - b;
      //     });
      //   let unknownList = JSON.parse(
      //     JSON.stringify(this.data_list.unknownList)
      //   );
      //   this.option.yAxis.data = [];
      //   for (let count of this.option.series[0].data) {
      //     for (let [index, ngword] of unknownList.entries()) {
      //       if (count == ngword.count) {
      //         this.option.yAxis.data.push(ngword.operatorName);
      //         unknownList.splice(index, 1);
      //         break;
      //       }
      //     }
      //   }
      // } else {
      //   this.option.legend.selected["NGワード"] = false;
      //   this.option.legend.selected["NGマナー"] = false;
      //   this.option.series[0].data = [];
      //   this.option.series[1].data = [];
      //   this.option.yAxis.data = this.operatorList.map((v) => v.operatorName);
      // }
    },
    // onClick(params) {
      // let user_id = _.find(this.operatorList, { operatorName: params.name })
      //   .user_id;

      // let ageAndSexStr = '';
      // if (this.$root.ageForEchart != '') {
      //   ageAndSexStr += "&f%5B%5D=cf_89&op%5Bcf_89%5D=~&v%5Bcf_89%5D%5B%5D=" + this.$root.ageForEchart[0];
      // }
      // if (this.$root.sexForEchart != '') {
      //   ageAndSexStr += "&f%5B%5D=cf_90&op%5Bcf_90%5D=~&v%5Bcf_90%5D%5B%5D=" + this.$root.sexForEchart[0];
      // }
      // if (params.seriesName == "不明") {
      //   window.open(
      //     this.$root.redmineUrl +
      //       "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=assigned_to_id&op%5Bassigned_to_id%5D=%3D&v%5Bassigned_to_id%5D%5B%5D=" +
      //       user_id +
      //       "&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
      //       this.datePicker[0] +
      //       "&v%5Bcreated_on%5D%5B%5D=" +
      //       this.datePicker[1] +
      //       "&f%5B%5D=cf_47&op%5Bcf_47%5D=*&f%5B%5D=cf_85&op%5Bcf_85%5D=%3D&v%5Bcf_85%5D%5B%5D=NEXMO_ASTERISK_PBX_MODE&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
      //       + ageAndSexStr
      //   );
      // } else {
      //   window.open(
      //     this.$root.redmineUrl +
      //       "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=assigned_to_id&op%5Bassigned_to_id%5D=%3D&v%5Bassigned_to_id%5D%5B%5D=" +
      //       user_id +
      //       "&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
      //       this.datePicker[0] +
      //       "&v%5Bcreated_on%5D%5B%5D=" +
      //       this.datePicker[1] +
      //       "&f%5B%5D=cf_46&op%5Bcf_46%5D=*&f%5B%5D=cf_85&op%5Bcf_85%5D=%3D&v%5Bcf_85%5D%5B%5D=NEXMO_ASTERISK_PBX_MODE&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
      //       + ageAndSexStr
      //   );
      // }
    // },
  },
};
</script>
<style>
.el-input__inner {
  height: 35px;
  line-height: 35px;
}
</style>